// Basic in-memory blog data and helpers

export const blogPosts = [
  {
    id: 1,
    slug: "introducing-agentic-farms",
    title: "Introducing Agentic Farms",
    date: "2025-08-12",
    author: "Agentic Farms Team",
    tags: ["announcement", "agents"],
    excerpt:
      "We’re excited to share our mission and how AI agents are transforming work.",
    content: `
      <p>Welcome to our blog! At Agentic Farms, we build AI agents that create leverage for teams of all sizes. In this post, we’ll share our vision, how we work, and what to expect from this blog.</p>
      <h3>Our Mission</h3>
      <p>We believe nobody works harder than an AI agent when it is designed around your workflows and brand.</p>
      <h3>What to Expect</h3>
      <ul>
        <li>Case studies</li>
        <li>Playbooks and templates</li>
        <li>Strategy and product updates</li>
      </ul>
    `,
  },
  {
    id: 2,
    slug: "sales-crm-agent-playbook",
    title: "Sales & CRM Agent Playbook",
    date: "2025-09-05",
    author: "Agentic Farms Team",
    tags: ["sales", "crm", "playbook"],
    excerpt:
      "A practical guide to deploying an AI agent for CRM hygiene, follow-ups, and reporting.",
    content: `
      <p>This playbook covers how to deploy a sales co-pilot: from CRM cleanup to follow-up automation and reporting.</p>
      <h3>Outcomes</h3>
      <p>Expect better pipeline visibility and faster sales cycles with less manual toil.</p>
    `,
  },
];

export function sortPostsByDateDesc(posts = blogPosts) {
  return [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));
}

export function getPostBySlug(slug) {
  return blogPosts.find((p) => p.slug === slug);
}

export function getPostIndexBySlug(slug) {
  return sortPostsByDateDesc().findIndex((p) => p.slug === slug);
}

export function searchPosts(query) {
  if (!query) return sortPostsByDateDesc();
  const q = query.toLowerCase();
  return sortPostsByDateDesc().filter((p) => {
    return (
      p.title.toLowerCase().includes(q) ||
      p.excerpt.toLowerCase().includes(q) ||
      (p.author && p.author.toLowerCase().includes(q)) ||
      (p.tags && p.tags.join(" ").toLowerCase().includes(q))
    );
  });
}


